import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { LanguageSwitchService } from "../../Services/LanguageSwitch/language-switch.service";
import { UserManager } from "../../Services/UserManager/user-manager";

@Component({
  selector: "app-language-switch",
  templateUrl: "./language-switch.component.html",
  styleUrls: ["./language-switch.component.css"],
})
export class LanguageSwitchComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private um: UserManager
  ) {
    const code = this.route.snapshot.paramMap.get("code");
    code && this.um.updateLanguagePreference(code);
    this.router.navigate(["home"]);
  }

  ngOnInit(): void {}
}
